import { ValidationRuleTriggers } from "./triggers";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { localize } from "client_legacy/ndaw/culture";

class HasMaxLengthRule extends ValidationRuleTriggers<string | null> {
	private readonly _maxLength: number;
	private readonly _alternativeMessage: string | undefined;

	constructor (maxLength: number, alternativeMessage?: string) {
		super();
		this._maxLength = maxLength;
		this._alternativeMessage = alternativeMessage;
	}

	public validate(value: string | null): InputValidationResult {
		if (!value) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		if (value.length > this._maxLength) {
			return {
				kind: InputValidationResultKind.Invalid,
				errorMessage: (this._alternativeMessage || localize("_TheMaximumLengthIsAmountCharacters"))
					.replace("{{amount}}", this._maxLength.toString())
			};
		}

		return {
			kind: InputValidationResultKind.Valid
		};
	}
}

class DoesMatchRegExpRule extends ValidationRuleTriggers<string | null> {
	private readonly _regexp: RegExp;
	private readonly _message: string;

	constructor(regexp: RegExp, message: string) {
		super();
		this._regexp = regexp;
		this._message = message;
	}

	public validate(value: string | null): InputValidationResult {
		if (!value || this._regexp.test(value)) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: this._message
		};
	}
}

class IsUrlRule extends ValidationRuleTriggers<string | null> {
	private readonly _allowHttpsOnly: boolean;
	private readonly _allowQueryString: boolean;
	private readonly _alternativeMessage: string | undefined;
	private readonly _alternativeMessageForNonHttps: string | undefined;

	constructor(
		allowHttpsOnly: boolean,
		allowQueryString: boolean,
		alternativeMessage?: string,
		alternativeMessageForNonHttps?: string
	) {
		super();
		this._allowHttpsOnly = allowHttpsOnly;
		this._allowQueryString = allowQueryString;
		this._alternativeMessage = alternativeMessage;
		this._alternativeMessageForNonHttps = alternativeMessageForNonHttps;
	}

	public validate(value: string | null): InputValidationResult {
		if (!value) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		try {
			const url = new URL(value);
			if (this._allowHttpsOnly && url.protocol !== "https:") {
				return {
					kind: InputValidationResultKind.Invalid,
					errorMessage: this._alternativeMessageForNonHttps || localize("_ValidUrlButNotHttps")
				};
			}

			// ideally url.search should be used, however it appears that if you only have an "?", it
			// is not placed in the url.search field
			if (!this._allowQueryString && url.href.includes("?")) {
				return {
					kind: InputValidationResultKind.Invalid,
					errorMessage: localize("_ValidUrlButHasQueryString")
				};
			}
		} catch (e){
			return {
				kind: InputValidationResultKind.Invalid,
				errorMessage: this._alternativeMessage || localize("_NotAValidUrl")
			};
		}

		return {
			kind: InputValidationResultKind.Valid
		};
	}
}

export {
	HasMaxLengthRule,
	DoesMatchRegExpRule,
	IsUrlRule
};